import React from 'react';
import { Markdown as MD } from '@features/markdown/components/Markdown';

const Markdown = ({ attributes: { value } }) => {
  return <MD source={value} />;
};

export default Markdown;
